import cryptoWalletValidator from 'multicoin-address-validator'

const specialCharsRegex = /[!@#$%^&*(),.?`~"_:{}';|<>\][\\/-]/
const upperCaseRegex = /[A-Z]+/
const lowerCaseRegex = /[a-z]+/
const numbersRegex = /[0-9]/
const alphanumericRegex = /^[A-Za-z0-9_]*$/

const postalCodeRegexes = {
  US: /^(\d{5}-\d{4}|\d{5})$/,
  CA: /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z]\s?[0-9][A-Z][0-9]$$/i,
  SG: /^\d{6}$/,
  AU: /^\d{4}$/,
  NZ: /^\d{4}$/,
}

const postalCodeLength = {
  US: 5,
  CA: 6,
  NZ: 4,
  SG: 6,
  AU: 4,
}

const postalCodeRegexesOnlyZeros = {
  US: /^([^1-9]{5}-[^1-9]{4}|[^1-9]{5})$/,
  CA: /$.^/,
  SG: /^[^1-9]{6}$/,
  AU: /^[^1-9]{4}$/,
  NZ: /^[^1-9]{4}$/,
}

export const validatePostalCode = (code, country) =>
  postalCodeRegexes[country].test(code) && !postalCodeRegexesOnlyZeros[country].test(code)

export const validateUserHandleChars = (str) => alphanumericRegex.test(str)

export const validatePostalCodeLength = (code, country) => (code ? code.length >= postalCodeLength[country] : false)

export const validatePasswordForNumbers = (str) => numbersRegex.test(str)
export const validatePasswordForSpecChars = (str) => specialCharsRegex.test(str)
export const validatePasswordForUppercase = (str) => upperCaseRegex.test(str)
export const validatePasswordForLowercase = (str) => lowerCaseRegex.test(str)

export const validateVerificationCode = (code) => {
  if (typeof code !== 'string') {
    return false
  }
  return code.length === 6 && /^\d+$/.test(code)
}

// Crypto wallet validator
export const validateWalletAddress = (walletAddress, cryptoName) => {
  try {
    const currency = cryptoWalletValidator.findCurrency(cryptoName)
    const isValid = cryptoWalletValidator.validate(walletAddress, cryptoName)
    if (typeof currency.validator?.verifyChecksum !== 'function') {
      return isValid
    }
    return isValid && currency.validator.verifyChecksum(walletAddress)
  } catch (error) {
    return false
  }
}
